import { render, staticRenderFns } from "./EndPostulation.vue?vue&type=template&id=5d82bfd2"
import script from "./EndPostulation.vue?vue&type=script&lang=ts"
export * from "./EndPostulation.vue?vue&type=script&lang=ts"
import style0 from "./EndPostulation.vue?vue&type=style&index=0&id=5d82bfd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports